module.exports = __webpack_public_path__ + "staticcomp/img/content_4.f466a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/content_4.png
// module id = COXS
// module chunks = 39